import React, { useState } from "react";
import SelectControl from "../SelecControl/SelectControl";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace } from "@fortawesome/free-solid-svg-icons";

const RRAtributoFichaTecnica = ({atributo,handleChange,handleDelete,setData,index,modo,setShowAdd,setNuevoEditado,setIndexToUpdate,optionsAtributos}) =>{

    return <div className={`rrAtributoFichaTecDiv ${modo != 'Vista' ? 'fiveColumns' : ''}`}>
        {modo != 'Vista' && <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '5%', height: '40px', marginTop: "5px", cursor: "pointer" }} className="deleteIconRR" onClick={()=>handleDelete(atributo,index)}/>}
            
        <SelectControl placeholder={"Seleccione un atributo..."} modo={modo} idSelect={"atributo"} handleChengeSelect={handleChange} optionsSelect={optionsAtributos} 
        valueSeleccionada={atributo.atributo} propToChange="atributo" tipo={'fichaTecnica'} selectSelect={handleChange} setData={setData} setIndexToUpdate={setIndexToUpdate} index={index} setNuevoEditado={setNuevoEditado} setShowAdd={setShowAdd}/>

        <input onChange={(e) => handleChange(e,index)} value={atributo.valor} disabled={modo == 'Vista'} name="valor"/>

        <input onChange={(e) => handleChange(e,index)} value={atributo.textAdic} disabled={modo == 'Vista'} name="textAdic"/>
    </div>

}

export default RRAtributoFichaTecnica;